var TEMPLATE_URL = require('./chooser.html');
angular.module('ikeweb.locale').directive('localeChooser', [

    function() {
        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            scope: {
                displayEvent: '@',
                dismissEvent: '@'
            },
            controller: 'LocaleChooserController',
            controllerAs: 'ctrl',
            link: function($scope, $element, attrs, ctrl) {
                $scope.selected = {};
                $scope.$watch(ctrl.getCurrentLocale, function(locale) {
                    $scope.selected.locale = locale;
                });
            }
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/locale/chooser/chooser.directive.js
// module id = 482
// module chunks = 0